import { Chip, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import {
  NON_ROUTABLE_STATUS_COLOR,
  NON_ROUTABLE_STATUS_LABEL,
} from '../constants/nonRoutableRequests';

// What each status MEANS for the prescription, because that is the operator's real question and
// the status word alone does not answer it.
const STATUS_TOOLTIP = {
  PENDING: 'Parked. Nothing has been filled and no partner has been told.',
  RESOLUTION_IN_PROGRESS:
    'Somebody is resolving this, or a resolution failed part-way. Do not act on it — check with ' +
    'engineering first.',
  RESOLVED: 'Released into the normal POM flow. An order exists and will be dispensed.',
  CANCELLED: 'Ended permanently. This prescription will never be filled.',
};

const NonRoutableRequestStatusChip = ({ status }) => (
  <Tooltip title={STATUS_TOOLTIP[status] ?? ''} arrow>
    <Chip
      size='small'
      variant='outlined'
      color={NON_ROUTABLE_STATUS_COLOR[status] ?? 'default'}
      label={NON_ROUTABLE_STATUS_LABEL[status] ?? status}
      data-testid={`non-routable-status-${status}`}
      sx={{ fontWeight: 500 }}
    />
  </Tooltip>
);

NonRoutableRequestStatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};

export default NonRoutableRequestStatusChip;
